import { FilterOption, FilterMenuOptions, ConnectionsOperatorTypes, ExactLevelTypes, FilterTypes } from 'app/components/filters/types';
import { createFilterMenuOptions } from '../filter-menu-options';

export const createAdvancedField = (options: FilterOption[], advancedSearchType: FilterTypes) => {

  const menuOptions = createFilterMenuOptions(advancedSearchType);

  const exclude = menuOptions && FilterMenuOptions.Exclude in menuOptions
    ? (options && options.some(option => option && option.option === FilterMenuOptions.Exclude)
      ? {
        conditionOperator2: { v: ConnectionsOperatorTypes.exclude }
      }
      : {
        conditionOperator2: { v: ConnectionsOperatorTypes.include }
      })
    : {};

  const exactLevel = menuOptions && FilterMenuOptions.ExcludeSubLevels in menuOptions
    ? (options && options.some(option => option && option.option === FilterMenuOptions.ExcludeSubLevels)
      ? {
        exactLevel: ExactLevelTypes.exclude
      }
      : {
        exactLevel: ExactLevelTypes.include
      })
    : {};

  return {
    ...exclude,
    ...exactLevel
  };
};
